import { Price } from '../../PaymentGateway/interfaces/Price';
import { CurrencyCode } from '../../PaymentGateway/interfaces/currencies';

export const buildTierByCurrency = (
  tipPricingTier: any,
  currency: CurrencyCode,
) => {
  const webPrices = tipPricingTier.tipsters;

  for (let key in webPrices.prices) {
    if (webPrices.prices[key].currency === currency) {
      return new Price(
        webPrices.prices[key].amount,
        webPrices.prices[key].currency,
        webPrices.prices[key].decimals,
      );
    }
  }

  return new Price(
    webPrices.default_price.amount,
    webPrices.default_price.currency,
    webPrices.default_price.decimals,
  );
};
